import { Component } from '@angular/core';
@Component({
  selector: 'app-explorer-icon',
  templateUrl: './explorer-icon.component.html',
  styleUrls: ['./explorer-icon.component.scss'],
})
export class ExplorerIconComponent {
  constructor() {}
}
